import type { DemoAppointmentPatientSex } from "@emr/contracts";

/**
 * The sex choices on every patient form, in the order and words they are shown: booking and
 * the questionnaire record the same registration values ("Prefer not to say" is `unknown`).
 */
export const sexOptions: ReadonlyArray<{
  readonly value: DemoAppointmentPatientSex;
  readonly label: string;
}> = [
  { value: "female", label: "Female" },
  { value: "male", label: "Male" },
  { value: "other", label: "Other" },
  { value: "unknown", label: "Prefer not to say" },
];

export function sexLabel(value: DemoAppointmentPatientSex | ""): string {
  return sexOptions.find((option) => option.value === value)?.label ?? "Not provided";
}
